<template>
  <button
    v-if="showFlashcardIdButton"
    @click="handleClick"
  >
    {{ buttonText }}
  </button>
</template>

<script>
export default {
  props: {
    resource: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      copied: false,
    };
  },
  computed: {
    showFlashcardIdButton() {
      return this.$store.getters['session/currentUser']?.previewer && this.resource?.id;
    },
    buttonText() {
      return this.copied ? 'Copied to clipboard!' : this.resource.id;
    },
  },
  methods: {
    async handleClick() {
      try {
        await navigator.clipboard.writeText(this.resource.id);
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 1200);
      } catch (err) {
        console.error('Failed to copy: ', err);
      }
    },
  },
};
</script>

<style scoped lang="scss">
button {
  background-color: transparent;
  border: none;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 11px;
  position: fixed;
  z-index: 1000;
  margin-top: 10px;
  margin-left: 40px;
  cursor: pointer;

  @include breakpoint(small) {
    display: none;
  }

  @include breakpoint(medium) {
    display: none;
  }
}
</style>
